var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.7373 0.8125C1.12193 0.8125 0.612305 1.32213 0.612305 1.9375V12.0625C0.612305 12.6779 1.12193 13.1875 1.7373 13.1875H11.8623C12.4777 13.1875 12.9873 12.6779 12.9873 12.0625V1.9375C12.9873 1.32213 12.4777 0.8125 11.8623 0.8125H1.7373ZM1.7373 1.9375H11.8623V12.0625H8.94405V8.26562H10.4032L10.6141 6.57812H8.94462V5.488C8.94462 4.99638 9.06499 4.66225 9.77037 4.66225H10.6844V3.13281C10.5286 3.11313 9.98805 3.07994 9.36649 3.07994C8.06993 3.07994 7.1868 3.86013 7.1868 5.3125V6.57812H5.71024V8.26562H7.18624V12.0625H1.7373V1.9375Z",
    fill: "#572148"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.8e46aa99c8251e6e2fd936e1e21da7c5.svg";
export { ForwardRef as ReactComponent };